import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { CheckoutPaymentConnector } from '@spartacus/checkout/base/core';
import { LoggerService, tryNormalizeHttpError } from '@spartacus/core';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { CustomCheckoutActions } from '../actions';

@Injectable()
export class CardTypesEffects {
  protected logger = inject(LoggerService);
  loadCardTypes$: Observable<CustomCheckoutActions.LoadCardTypesSuccess | CustomCheckoutActions.LoadCardTypesFail> = createEffect(() =>
    this.actions$.pipe(
      ofType(CustomCheckoutActions.LOAD_CARD_TYPES),
      switchMap(() => {
        return this.checkoutPaymentConnector.getPaymentCardTypes().pipe(
          map((cardTypes) => new CustomCheckoutActions.LoadCardTypesSuccess(cardTypes)),
          catchError((error) => of(new CustomCheckoutActions.LoadCardTypesFail(tryNormalizeHttpError(error, this.logger))))
        );
      })
    )
  );

  constructor(private actions$: Actions, private checkoutPaymentConnector: CheckoutPaymentConnector) {}
}
